import { render } from "./SportsAlertsTable.vue?vue&type=template&id=5c1b0d9d&ts=true"
import script from "./SportsAlertsTable.vue?vue&type=script&lang=ts"
export * from "./SportsAlertsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__